<template>
    <card>
        <card-header>
            <card-overline>Kundenangebote erstellen</card-overline>
        </card-header>
        <card-content>
            <table class="table table--stripped table--card">
                <thead>
                <tr>
                    <th>
                        PF-Nr
                    </th>
                    <th>
                        Kunde
                    </th>
                    <th class="text-right">
                        Stückzahl
                    </th>
                    <th class="text-right">
                        Liefertermin
                    </th>
                    <th class="text-center">
                        erhaltene Angebote
                    </th>
                    <th class="text-right">
                        Anfrageende
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="offerAskForQuote in createOfferAskForQuotesTable" :key="offerAskForQuote.index">
                    <td>
                        <Link
                            :href="$$route('ask-for-quote', {'askForQuote': offerAskForQuote.id} )">
                            {{ offerAskForQuote.pfnumber }}
                        </Link>
                    </td>
                    <td>{{ offerAskForQuote.client_user.company }}</td>
                    <td class="text-right" v-html="offerAskForQuote.lot_qty"></td>
                    <td class="text-right">{{ offerAskForQuote.delivery_date_string }}</td>
                    <td class="text-center">
                        {{ offerAskForQuote.bid_round_member_offers_count }}
                    </td>
                    <td class="text-right">{{ offerAskForQuote.bid_round_end_string }}</td>
                </tr>
                </tbody>
            </table>
        </card-content>
    </card>
</template>

<script>
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardContent from '@partfactory/Shared/Card/CardContent';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
export default {
    name: 'CreateClientOffer',
    components: {CardOverline, CardContent, CardHeader, Card},
    props: {
        createOfferAskForQuotes: Object,
    },
    computed: {
        createOfferAskForQuotesTable() {

            let askForQuotes = Array;

            return Object.keys(this?.createOfferAskForQuotes).map(key => {
                askForQuotes[key] = this.createOfferAskForQuotes[key];
                askForQuotes[key].delivery_date_string = askForQuotes[key].delivery_date ? this.$date(askForQuotes[key].delivery_date) : 'k.A.';
                askForQuotes[key].created_at_string = this.$date(askForQuotes[key].created_at);
                askForQuotes[key].bid_round_end_string = this.$date(askForQuotes[key].bid_rounds[askForQuotes[key].bid_rounds.length-1].ending_at);

                let lotQty = [];
                lotQty.push(askForQuotes[key].lotqty_1, askForQuotes[key].lotqty_2, askForQuotes[key].lotqty_3, askForQuotes[key].lotqty_4);
                askForQuotes[key].lot_qty = lotQty.filter(lot => lot !== null).join(', ');

                return askForQuotes[key];
            });
        },
    },
};
</script>
